exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-date {\n  position: relative;\n}\n.field-date:last-child {\n  margin-top: 20px;\n}", ""]);

// exports
